// extracted by mini-css-extract-plugin
export default {"containerListTable":"DetailedStockTable_containerListTable__7X6Ts"};